(function (ws, win) {
    'use strict';
    ws.views.quoteDetailView = ws.views.staticTable.extend ({
        events: {
            'click .optional-tab': 'selectTab',
            'click .switch-to-multi': 'switchToMultiView',
            'click .switch-to-standard': 'swicthToStandardView'
        },

        /**
         * Initialize
         */
        initialize: function () {
            // TODO - Componentize this crap
        },

        switchToMultiView: function () {
            this.$('.switch-to-multi').css('display', 'none');
            this.$('.switch-to-standard').css('display', 'block');
            $('.multi-config-table').removeClass('hidden');
            $('.standard-table').addClass('hidden');
        },

        swicthToStandardView: function () {
            this.$('.switch-to-standard').css('display', 'none');
            this.$('.switch-to-multi').css('display', 'block');
            $('.standard-table').removeClass('hidden');
            $('.multi-config-table').addClass('hidden');
        },

        selectTab: function(e) {
            setTimeout(function() {
                $('.qut-fixed-detail').removeClass('fixed');
            }, 1000);
            let tabNumber = this.$(e.currentTarget).data('tabNumber');
            this.$table = this.$(`#quotedetail-table${tabNumber}`);
            ws.views.staticTable.prototype.initialize.call(this);
        }
    });
})(westcon, window);
